import React from 'react';

if (process.browser) require('./Icon.scss');

export default function Icon({
  name,
  position = 'before',
  spin,
  className = '',
}) {
  return (
    <i className={`with-icon-${position} ${name ? `icon-${name}` : ''} ${spin ? 'spin-icon' : ''} ${className}`} />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Icon/Icon.js